module.exports = __webpack_public_path__ + "img/sensing.813126bc.jpg";